import { Util } from '../_util.js';
import { gsap, ScrollToPlugin,  ScrollTrigger,  MotionPathPlugin } from 'gsap/all';


const Sliders = {
    heroBannerSlider: function() {

        if($('.js-heroBannerSlider')[0]) {
            let $slider = $('.js-heroBannerSlider');    
            let $infoSlider = $('.js-heroBannerInfoSlider');
            
            $slider
            .on('init', function(event, slick, direction) {
                for (var i = 1; i < slick.$slides.length + 1; i++) {
                  $('.js-heroBannerSlider .slick-dots li:nth-child(' + i + ')').append(
                    '<div class="heroBanner__timer sliderNavigation__timer"><svg><circle  r="10" cx="12" cy="12"></circle><circle class="static" r="10" cx="12" cy="12"></circle></svg></div>'
                  );
                  if (i == slick.$slides.length) {
                    addClass();
                  }
                }
        
                function addClass() {
                  for (var i = 1; i < slick.$slides.length + 1; i++) {        
                    $(
                      '.hero-banner-slider .slick-dots li:nth-child(' +
                        i +
                        ')  .heroBanner__timer'
                    ).addClass('' + (i - 1) + '');
                  }
                }
        
                $('.hero-banner-slider  .slick-dots li .0 svg circle:nth-child(1)').addClass('animated');
                $('.hero-banner-slider  .slick-dots li .0 svg circle:nth-child(2)').addClass('animatedbg');

                $('.hero-banner__navigation').append($('.hero-banner-slider .slick-dots'));
                $('.hero-banner__navigation .slick-dots').append($('.hero-banner-slider .icon-slider-pause'));
            })
            .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                $('.hero-banner-slider .slick-dots li svg circle:nth-child(1)').removeClass('animated');
                $('.hero-banner-slider .slick-dots li svg circle:nth-child(2)').removeClass('animatedbg');
                let current = slick.$slides.get(nextSlide);
                let currentId = $(current).attr('data-slick-index');
        
                $('.hero-banner-slider .slick-dots .' + currentId + ' svg circle:nth-child(1)').addClass(
                  'animated'
                );
                $('.hero-banner-slider .slick-dots .' + currentId + ' svg circle:nth-child(2)').addClass(
                  'animatedbg'
                );

                $(".hero-banner__info .icon-slider-pause").removeClass('paused');
                $('.heroBanner__timer svg circle.animated').css('animation-play-state','running');

            })
            .slick({
                dots: true,
                arrows: false,
                slidesToShow: 1,
                speed: 1000,
                fade: true,
                easing: 'ease-out',
                autoplay: true,
                autoplaySpeed: 6000,
                pauseOnFocus: false,
                pauseOnHover: false,
                pauseOnDotsHover: false,
                asNavFor: $infoSlider
            })


            $infoSlider
            .slick({
              dots: false,
              arrows: false,
              slidesToShow: 1,
              speed: 1000,
              fade: true,
              easing: 'ease-out',
              //autoplay: true,
              autoplaySpeed: 6000,
              pauseOnFocus: false,
              pauseOnHover: false,
              pauseOnDotsHover: false,
              asNavFor: $slider
          })


            $('.hero-banner__info .icon-slider-pause svg').on('click', function() {
                if ( !$(this).parent().hasClass('paused')) {
                    $slider.slick('slickPause')
                    $(this).parent().addClass('paused');
                    $('.heroBanner__timer svg circle.animated').css('animation-play-state','paused');
                    
                } else {
                    $slider.slick('slickPlay')
                    $(this).parent().removeClass('paused');
                    $('.heroBanner__timer svg circle.animated').css('animation-play-state','running');
                }
    
            })
        }
        
    },
    homeProductSlider: function() {


      if($('.js-productSlider')[0]) {
          let $slider = $('.js-productSlider'); 
            

          $slider.slick({
            slidesToShow: 1,
            dots: false,
            arrows: true,
            swipe: true,
            fade: true,
            swipeToSlide: true,
            adaptiveHeight: false,
            prevArrow: $('.product-slider__navigation .prev'),
            nextArrow: $('.product-slider__navigation .next'),
            speed: 500,
            responsive: [
              {
                  breakpoint: 992,
                  settings: {
                    adaptiveHeight: true,
                    lazyLoad: 'ondemand'
                  }
              },
            ]
        })
        .on('lazyLoaded', function(event, slick, image, imageSource) {
          slick.resize();
        });

      }
    },
    // init: function (e, slick) {
    //   slick.$slider.find('img').first().on('load', function () {
    //     $(window).trigger('resize');
    //   });
    // },
    mobileTileSlider: function() {


      if($('.js-mobileTileSlider')[0]) {
  
        //$(window).on('load', () => {
          const element = $('.js-mobileTileSlider');
          const mediaQuery = window.matchMedia('(max-width: 992px)');
        
          const handleSwitchSlick = ((e) => {
            if (e.matches) {
              element.on("init", function (event, slick) {
                ScrollTrigger.refresh(true);
              })
              element.slick({
                slidesToShow: 1,
                dots: false,
                arrows: true,
                swipe: true,
                fade: false,
                centerMode: true,
                swipeToSlide: true,
                adaptiveHeight: false,
                prevArrow: $('.mobileTile__navigation .prev'),
                nextArrow: $('.mobileTile__navigation .next'),
                speed: 500
              });
            } else if (element.hasClass('slick-initialized')) {
              element.slick('unslick');
            }
          });
        
          mediaQuery.addListener(handleSwitchSlick);
          handleSwitchSlick(mediaQuery);
       //});

      }
    },
    quotesSlider: function() {

      if($('.js-quotesSlider')[0]) {
        let $slider = $('.js-quotesSlider');    
        
        $slider
        .on('init', function(event, slick, direction) {
            for (var i = 1; i < slick.$slides.length + 1; i++) {
              $('.js-quotesSlider .slick-dots li:nth-child(' + i + ')').append(
                '<div class="quotesSlider__timer sliderNavigation__timer"><svg><circle  r="10" cx="12" cy="12"></circle><circle class="static" r="10" cx="12" cy="12"></circle></svg></div>'
              );
              if (i == slick.$slides.length) {
                addClass();
              }
            }
    
            function addClass() {
              for (var i = 1; i < slick.$slides.length + 1; i++) {        
                $(
                  '.quotes-slider .slick-dots li:nth-child(' +
                    i +
                    ')  .quotesSlider__timer'
                ).addClass('' + (i - 1) + '');
              }
            }
    
            $('.quotes-slider .slick-dots li .0 svg circle:nth-child(1)').addClass('animated');
            $('.quotes-slider .slick-dots li .0 svg circle:nth-child(2)').addClass('animatedbg');

            $('.quotes-slider__navigation').append($('.quotes-slider .slick-dots'));
            $('.quotes-slider__navigation .slick-dots').append($('.quotes-slider .icon-slider-pause'));
        })
        .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $('.quotes-slider .slick-dots li svg circle:nth-child(1)').removeClass('animated');
            $('.quotes-slider .slick-dots li svg circle:nth-child(2)').removeClass('animatedbg');
            let current = slick.$slides.get(nextSlide);
            let currentId = $(current).attr('data-slick-index');
    
            $('.quotes-slider .slick-dots .' + currentId + ' svg circle:nth-child(1)').addClass(
              'animated'
            );
            $('.quotes-slider .slick-dots .' + currentId + ' svg circle:nth-child(2)').addClass(
              'animatedbg'
            );

            $(".quotes-slider__content .icon-slider-pause").removeClass('paused');
            $('.quotesSlider__timer svg circle.animated').css('animation-play-state','running');
        })
        .slick({
            dots: true,
            arrows: false,
            slidesToShow: 1,
            speed: 1000,
            fade: true,
            easing: 'ease-out',
            autoplay: true,
            autoplaySpeed: 6000,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,

        })

        $('.quotes-slider__navigation .icon-slider-pause svg').on('click', function() {
            if ( !$(this).parent().hasClass('paused')) {
                $slider.slick('slickPause')
                $(this).parent().addClass('paused');
                $('.quotesSlider__timer svg circle.animated').css('animation-play-state','paused');
                
            } else {
                $slider.slick('slickPlay')
                $(this).parent().removeClass('paused');
                $('.quotesSlider__timer svg circle.animated').css('animation-play-state','running');
            }

        })
    }
    },
    productQuotesSlider: function() {

      if($('.js-productQuotesSlider')[0]) {
        let $slider = $('.js-productQuotesSlider');    
        
        $slider
        .on('init', function(event, slick, direction) {
            for (var i = 1; i < slick.$slides.length + 1; i++) {
              $('.js-productQuotesSlider .slick-dots li:nth-child(' + i + ')').append(
                '<div class="quotesSlider__timer sliderNavigation__timer"><svg><circle  r="10" cx="12" cy="12"></circle><circle class="static" r="10" cx="12" cy="12"></circle></svg></div>'
              );
              if (i == slick.$slides.length) {
                addClass();
              }
            }
    
            function addClass() {
              for (var i = 1; i < slick.$slides.length + 1; i++) {        
                $(
                  '.products-quotes .slick-dots li:nth-child(' +
                    i +
                    ')  .quotesSlider__timer'
                ).addClass('' + (i - 1) + '');
              }
            }
    
            $('.products-quotes .slick-dots li .0 svg circle:nth-child(1)').addClass('animated');
            $('.products-quotes .slick-dots li .0 svg circle:nth-child(2)').addClass('animatedbg');

            $('.products-quotes__navigation').append($('.products-quotes .slick-dots'));
            $('.products-quotes__navigation .slick-dots').append($('.products-quotes .icon-slider-pause'));
        })
        .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $('.products-quotes .slick-dots li svg circle:nth-child(1)').removeClass('animated');
            $('.products-quotes .slick-dots li svg circle:nth-child(2)').removeClass('animatedbg');
            let current = slick.$slides.get(nextSlide);
            let currentId = $(current).attr('data-slick-index');
    
            $('.products-quotes .slick-dots .' + currentId + ' svg circle:nth-child(1)').addClass(
              'animated'
            );
            $('.products-quotes .slick-dots .' + currentId + ' svg circle:nth-child(2)').addClass(
              'animatedbg'
            );
        })
        .slick({
            dots: true,
            arrows: false,
            slidesToShow: 1,
            speed: 1000,
            fade: true,
            easing: 'ease-out',
            autoplay: true,
            autoplaySpeed: 6000,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,

        })

        $('.products-quotes__navigation .icon-slider-pause svg').on('click', function() {
            if ( !$(this).parent().hasClass('paused')) {
                $slider.slick('slickPause')
                $(this).parent().addClass('paused');
                $('.quotesSlider__timer svg circle.animated').css('animation-play-state','paused');
                
            } else {
                $slider.slick('slickPlay')
                $(this).parent().removeClass('paused');
                $('.quotesSlider__timer svg circle.animated').css('animation-play-state','running');
            }

        })
    }
    },
    latestArticleSlider: function() {


      if($('.js-latestArticlesSlider')[0]) {
          let $slider = $('.js-latestArticlesSlider'); 

          $slider.slick({
            slidesToShow: 1,
            dots: false,
            arrows: true,
            //adaptiveHeight: false,
            prevArrow: $('.latest-articles-all__navigation .prev'),
            nextArrow: $('.latest-articles-all__navigation .next'),
            speed: 500,
            mobileFirst: true,
            responsive: [
              {
                  breakpoint: 750,
                  settings: {
                      slidesToShow: 2
                  }
              },
            ]
        });

        $(".latest-articles__filters input").on('click', function(){
          var filter = $(this).data('filter');
          $slider.slick('slickUnfilter');
          
          if(filter == 'recipes'){
            $slider.slick('slickFilter','.recipes');
          }
          else if(filter == 'blog'){
            $slider.slick('slickFilter','.blog');
          }
          else if(filter == 'all'){
            
            $slider.slick('slickUnfilter');
          }
          
        })

      }
    },
    featuredCollections: function() {


      if($('.js-featuredCollections')[0]) {
          let $slider = $('.js-featuredCollections'); 

          $slider.slick({
            slidesToShow: 1,
            dots: false,
            arrows: true,
            swipe: true,
            fade: false,
            centerMode: true,
            swipeToSlide: true,
            adaptiveHeight: false,
            prevArrow: $('.featuredCollection__navigation .prev'),
            nextArrow: $('.featuredCollection__navigation .next'),
            speed: 500,
            mobileFirst: true,
            responsive: [
              {
                  breakpoint: 750,
                  settings: {
                      slidesToShow: 4,
                      centerMode: false
                  }
              },
            ]
            
        });

      }
    },
    aboutUsSlider: function() {


      if($('.js-aboutUsSlider')[0]) {
          let $slider = $('.js-aboutUsSlider'); 

          $slider.slick({
            slidesToShow: 1,
            dots: false,
            arrows: true,
            swipe: true,
            fade: false,
            swipeToSlide: true,
            adaptiveHeight: false,
            prevArrow: $('.timeline__navigation .prev'),
            nextArrow: $('.timeline__navigation .next'),
            speed: 500,
            
        });

      }
    },
    mobileAwardslider: function() {


      if($('.js-mobileAwardslider')[0]) {
  
        //$(window).on('load', () => {
          const element = $('.js-mobileAwardslider');
          const mediaQuery = window.matchMedia('(max-width: 767px)');
        
          const handleSwitchSlick = ((e) => {
            if (e.matches) {

              element.slick({
                slidesToShow: 1,
                dots: false,
                arrows: true,
                swipe: true,
                fade: false,
                centerMode: true,
                swipeToSlide: true,
                //adaptiveHeight: true,
                prevArrow: $('.awards-accolades__navigation .prev'),
                nextArrow: $('.awards-accolades__navigation .next'),
                speed: 500
              });
            } else if (element.hasClass('slick-initialized')) {
              element.slick('unslick');
            }
          });
        
          mediaQuery.addListener(handleSwitchSlick);
          handleSwitchSlick(mediaQuery);
       //});

      }
    },
    mobileVerticalColumSlider: function() {


      if($('.js-mobileVerticalColumnSlider')[0]) {
  
        //$(window).on('load', () => {
          const element = $('.js-mobileVerticalColumnSlider');
          const mediaQuery = window.matchMedia('(max-width: 767px)');
        
          const handleSwitchSlick = ((e) => {
            if (e.matches) {

              element.slick({
                slidesToShow: 1,
                dots: false,
                arrows: true,
                swipe: true,
                fade: false,
                centerMode: true,
                swipeToSlide: true,
                adaptiveHeight: false,
                prevArrow: $('.vertical-column-media__navigation .prev'),
                nextArrow: $('.vertical-column-media__navigation .next'),
                speed: 500
              });
            } else if (element.hasClass('slick-initialized')) {
              element.slick('unslick');
            }
          });
        
          mediaQuery.addListener(handleSwitchSlick);
          handleSwitchSlick(mediaQuery);
       //});

      }
    },
    collectionUsageSlider: function() {




      if($('.js-collectionUsageSlider')[0]) {


        let $slider = $('.js-collectionUsageSlider'); 

        $slider.slick({
          slidesToShow: 1,
          dots: true,
          arrows: false,
          swipe: true,
          fade: true,
          swipeToSlide: true,
          adaptiveHeight: false,
          speed: 1000,
          infinite: false
          
        });

        //Change ingredient info on ingredient click
        if ($('.js-CollectionIngredient')[0]) {

          $('.js-CollectionIngredient .ingredient-select').on('click', function() {
              let currentIndex = $(this).attr('ingredient-index');

              $('.js-CollectionIngredient .ingredient-select').removeClass('active');
              $(this).addClass('active');
              $('.js-CollectionIngredientInfo').removeClass('active');
              $('.js-CollectionIngredientInfo[ingredient-info-index=' + currentIndex + ']').addClass('active');
              $slider.slick('refresh');
          })
        }



        //Change slider on ingredient usage click
        $('.usage').click(function(e) {
          e.preventDefault();
          var slideno = $(this).data('slide');
          $slider.slick('slickGoTo', slideno - 1);
          $('.usage').removeClass('active');
          this.classList.add('active');
        });


      }

      if($('.js-onlyMainImage')[0]) {
        //Change ingredient info on ingredient click
        if ($('.js-CollectionIngredient')[0]) {

          $('.js-CollectionIngredient .ingredient-select').on('click', function() {
              let currentIndex = $(this).attr('ingredient-index');

              $('.js-CollectionIngredient .ingredient-select').removeClass('active');
              $(this).addClass('active');
              $('.js-CollectionIngredientInfo').removeClass('active');
              $('.js-CollectionIngredientInfo[ingredient-info-index=' + currentIndex + ']').addClass('active');
          })
        }


      }


    },
    mobileCraftCircularSlider: function() {


      if($('.js-mobileCraftCircular')[0]) {
  
        //$(window).on('load', () => {
          const element = $('.js-mobileCraftCircular');
          const mediaQuery = window.matchMedia('(max-width: 480px)');
        
          const handleSwitchSlick = ((e) => {
            if (e.matches) {
              element.on("init", function (event, slick) {
                ScrollTrigger.refresh(true);
              })
              element.slick({
                slidesToShow: 1,
                dots: false,
                arrows: true,
                swipe: true,
                fade: false,
                centerMode: true,
                swipeToSlide: true,
                adaptiveHeight: false,
                prevArrow: $('.mobileTile__navigation .prev'),
                nextArrow: $('.mobileTile__navigation .next'),
                speed: 500
              });
            } else if (element.hasClass('slick-initialized')) {
              element.slick('unslick');
            }
          });
        
          mediaQuery.addListener(handleSwitchSlick);
          handleSwitchSlick(mediaQuery);
       //});

      }
    },
    init: function() {
        this.heroBannerSlider();
        this.homeProductSlider();
        this.quotesSlider();
        this.productQuotesSlider();
        this.mobileTileSlider();
        this.latestArticleSlider();
        this.featuredCollections();
        this.aboutUsSlider();
        this.mobileAwardslider();
        this.mobileVerticalColumSlider();
        this.collectionUsageSlider();
        this.mobileCraftCircularSlider();
    }
};

export default Sliders;
